const WhoItsForSection = () => {
  const audiences = [
    {
      title: "Individual agents",
      description: "Personal websites that establish your name and reputation independent of brokerage pages.",
    },
    {
      title: "Team leaders",
      description: "Dedicated sites that position your team's approach and make it easy for clients to reach you.",
    },
    {
      title: "Brokerages & investors",
      description: "Professional web presence that builds trust and supports direct inquiries.",
    },
  ];

  return (
    <section className="section-padding">
      <div className="container-narrow">
        <div className="text-center mb-12">
          <h2 data-reveal className="text-3xl md:text-4xl font-semibold mb-4 text-primary">
            Built Specifically for Real Estate
          </h2>
          <p data-reveal style={{ transitionDelay: "100ms" }} className="text-soft text-lg max-w-2xl mx-auto">
            If your website is meant to represent your name, reputation, and business — this is for you.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {audiences.map((audience, index) => (
            <div 
              key={index}
              data-reveal
              style={{ transitionDelay: `${200 + index * 120}ms` }}
              className="p-8 bg-card rounded-xl border border-border/50 text-center"
            >
              <h3 className="text-lg font-semibold mb-3 text-foreground">
                {audience.title}
              </h3>
              <p className="text-soft leading-relaxed">
                {audience.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoItsForSection;
